(function () {
  'use strict';

  if (window.__landingPageCartInitialized) return;
  window.__landingPageCartInitialized = true;

  var SOURCE = 'landing-page-cart';
  var configCache = null;

  function getRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function readConfig() {
    if (configCache) return configCache;

    var node = document.getElementById('landing-page-cart-config');
    if (!node) return null;

    try {
      configCache = JSON.parse(node.textContent || '{}');
    } catch (error) {
      console.error('landing-page-cart: invalid config', error);
      configCache = null;
    }

    return configCache;
  }

  function parseDiscountFromHref(href) {
    if (!href) return '';
    var match = href.match(/\/discount\/([^/?&#]+)/i);
    return match ? decodeURIComponent(match[1]).trim() : '';
  }

  function parseCartRedirectFromHref(href) {
    if (!href) return null;

    var redirectMatch = href.match(/redirect=([^&]+)/i);
    var redirectPath = redirectMatch ? decodeURIComponent(redirectMatch[1]) : '';
    var cartMatch = (redirectPath || href).match(/\/cart\/(\d+)(?::(\d+))?/i);

    if (!cartMatch) return null;

    return {
      variantId: cartMatch[1],
      quantity: cartMatch[2] ? parseInt(cartMatch[2], 10) || 1 : 1,
    };
  }

  function resolveAddPayload(link) {
    var config = readConfig() || {};
    var href = link && link.getAttribute ? link.getAttribute('href') || '' : '';
    var redirectPayload = parseCartRedirectFromHref(href);
    var linkDiscountCode =
      link && link.dataset && link.dataset.discountCode
        ? String(link.dataset.discountCode).trim()
        : '';

    return {
      variantId: String((redirectPayload && redirectPayload.variantId) || config.variantId || ''),
      quantity: (redirectPayload && redirectPayload.quantity) || config.quantity || 1,
      productId: config.productId ? String(config.productId) : '',
      discountCode:
        linkDiscountCode || parseDiscountFromHref(href) || config.defaultDiscountCode || '',
    };
  }

  function dispatchCartUpdate(detail) {
    document.dispatchEvent(
      new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: detail.resource || {},
          sourceId: SOURCE,
          data: detail.data || {},
        },
      })
    );
  }

  function openUpcartDrawer() {
    if (typeof window.upcartOpenCart === 'function') {
      window.upcartOpenCart();
      return;
    }

    var attempts = 0;
    var interval = window.setInterval(function () {
      attempts += 1;
      if (typeof window.upcartOpenCart === 'function') {
        window.upcartOpenCart();
        window.clearInterval(interval);
      } else if (attempts >= 15) {
        window.clearInterval(interval);
      }
    }, 200);
  }

  function refreshUpcart() {
    if (typeof window.upcartRefreshCart === 'function') {
      window.upcartRefreshCart();
    }
  }

  function goToCheckout() {
    window.location.assign(getRoot() + 'checkout');
  }

  function finishCartAction(redirectToCheckout) {
    refreshUpcart();

    if (redirectToCheckout) {
      goToCheckout();
      return;
    }

    openUpcartDrawer();
  }

  function applyDiscountCode(discountCode, redirectToCheckout) {
    if (!discountCode) {
      finishCartAction(redirectToCheckout);
      return Promise.resolve();
    }

    return fetch(getRoot() + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ discount: discountCode }),
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Discount request failed (' + response.status + ')');
        }
        return response.json();
      })
      .then(function () {
        finishCartAction(redirectToCheckout);
      })
      .catch(function (error) {
        console.error('landing-page-cart: discount failed', error);
        finishCartAction(redirectToCheckout);
      });
  }

  function addToCart(payload) {
    if (!payload.variantId) {
      return Promise.reject(new Error('landing-page-cart: missing variant id'));
    }

    return fetch(getRoot() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: payload.variantId,
        quantity: payload.quantity,
      }),
    }).then(function (response) {
      return response.json().then(function (body) {
        if (!response.ok || body.status) {
          var message = body.description || body.message || 'Add to cart failed';
          dispatchCartUpdate({
            data: {
              didError: true,
              source: SOURCE,
              itemCount: payload.quantity,
              productId: payload.productId,
              variantId: payload.variantId,
            },
          });
          throw new Error(message);
        }

        dispatchCartUpdate({
          resource: body,
          data: {
            didError: false,
            source: SOURCE,
            itemCount: payload.quantity,
            productId: payload.productId,
            variantId: payload.variantId,
          },
        });

        return body;
      });
    });
  }

  function handleLandingCartClick(event) {
    var link = event.currentTarget;
    if (!(link instanceof HTMLAnchorElement)) return;
    if (link.dataset.directCheckout === 'true') return;

    var payload = resolveAddPayload(link);
    if (!payload.variantId) return;

    event.preventDefault();

    if (link.dataset.landingCartPending === 'true') return;
    link.dataset.landingCartPending = 'true';

    var redirectToCheckout = link.dataset.redirectCheckout === 'true';

    addToCart(payload)
      .then(function () {
        return applyDiscountCode(payload.discountCode, redirectToCheckout);
      })
      .catch(function (error) {
        console.error('landing-page-cart:', error);
      })
      .finally(function () {
        delete link.dataset.landingCartPending;
      });
  }

  function bindLandingCartTriggers() {
    var selectors = [
      '.offer_banner_section .offer_button_block a',
      'a.offer_button_block_trigger',
      '.landing_pg_column_block_sec .button_block .button',
      '.landing_page_sticky_atc_sec .new_landing_page_sticky_atc a',
    ];

    selectors.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (link) {
        if (!(link instanceof HTMLAnchorElement)) return;
        if (link.dataset.landingCartBound === 'true') return;
        link.dataset.landingCartBound = 'true';
        link.addEventListener('click', handleLandingCartClick);
      });
    });
  }

  var LANDING_SCROLL_OFFSET = 102;
  var PRIMARY_OFFER_HASH = '#offer_banner_sec';

  function getPrimaryOfferBanner() {
    return (
      document.getElementById('offer_banner_sec') ||
      document.getElementById('offer_banner_sec_bottom') ||
      document.getElementById('landing-pg-mobile-heading')
    );
  }

  function resolveLandingScrollTarget(hash) {
    var id = (hash || '').replace(/^#/, '');
    if (!id) return null;

    if (id === 'offer_banner_sec') {
      return getPrimaryOfferBanner();
    }

    if (id === 'offer_banner_sec_bottom' || id === 'try-it-risk-free') {
      return getPrimaryOfferBanner();
    }

    if (id === 'landing-pg-mobile-heading') {
      return document.getElementById('landing-pg-mobile-heading');
    }

    return document.getElementById(id);
  }

  function getLandingScrollHash(hash) {
    var id = (hash || '').replace(/^#/, '');
    if (
      id === 'offer_banner_sec_bottom' ||
      id === 'try-it-risk-free' ||
      id === 'offer_banner_sec'
    ) {
      var primary = document.getElementById('offer_banner_sec');
      if (primary) return PRIMARY_OFFER_HASH;
    }
    return hash;
  }

  function scrollToLandingTarget(target, behavior) {
    if (!target) return;
    var y = target.getBoundingClientRect().top + window.pageYOffset - LANDING_SCROLL_OFFSET;
    window.scrollTo({ top: Math.max(0, y), behavior: behavior || 'smooth' });
  }

  function bindLandingHashLinks() {
    document
      .querySelectorAll(
        'a[href="#offer_banner_sec"], a[href="#offer_banner_sec_bottom"], a[href="#try-it-risk-free"]'
      )
      .forEach(function (link) {
        if (!(link instanceof HTMLAnchorElement)) return;
        if (link.dataset.landingScrollBound === 'true') return;

        link.dataset.landingScrollBound = 'true';
        link.addEventListener('click', function (event) {
          var hash = link.getAttribute('href') || '';
          var target = resolveLandingScrollTarget(hash);
          if (!target) return;

          event.preventDefault();
          scrollToLandingTarget(target, 'smooth');

          var urlHash = getLandingScrollHash(hash);
          if (history.pushState) {
            history.pushState(null, '', urlHash);
          } else {
            window.location.hash = urlHash;
          }
        });
      });
  }

  function handleInitialLandingHash() {
    var hash = window.location.hash;
    if (!hash || !resolveLandingScrollTarget(hash)) return;

    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual';
    }

    var urlHash = getLandingScrollHash(hash);
    if (urlHash !== hash && history.replaceState) {
      history.replaceState(null, '', urlHash);
    }

    function correctScroll(behavior) {
      var target = resolveLandingScrollTarget(hash);
      if (target) scrollToLandingTarget(target, behavior);
    }

    correctScroll('auto');
    requestAnimationFrame(function () {
      correctScroll('auto');
    });

    window.addEventListener(
      'load',
      function () {
        correctScroll('auto');
      },
      { once: true }
    );

    window.setTimeout(function () {
      correctScroll('smooth');
    }, 400);

    window.setTimeout(function () {
      correctScroll('auto');
    }, 1200);
  }

  function init() {
    bindLandingHashLinks();
    handleInitialLandingHash();
    bindLandingCartTriggers();
  }

  window.LandingPageCart = {
    addFromLink: function (link) {
      handleLandingCartClick({ preventDefault: function () {}, currentTarget: link });
    },
    resolveAddPayload: resolveAddPayload,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
